// extracted by mini-css-extract-plugin
export default {"cls1":"VeloPasswordField-TextField_cls1__f6bfZ","cls2":"VeloPasswordField-TextField_cls2__6l0fu VeloPasswordField-TextField_cls1__f6bfZ"};